// extracted by mini-css-extract-plugin
export default {"inputTextBox":"InputTextBox_inputTextBox__UM3zG"};